// -------------------------------------------------------------------------------------
//export const IDENTITY_API_URL_KEY = 'https://identity.relamy.com/';
//export const API_URL_KEY = 'https://api.relamy.com/';
// -------------------------------------------------------------------------------------


// -------------------------------------------------------------------------------------
export const IDENTITY_API_URL_KEY = 'https://identity.relamy.com/';
export const API_URL_KEY = 'https://api.relamy.com/';
// -------------------------------------------------------------------------------------